{
  "publicOrganizationSelectDialog": {
    "title": "Choose an Organization",
    "subTitle": "This account is part of multiple organizations. Please, select one to continue."
  },
  "signUpNotAllowedDialog": {
    "title": "Unable to create account",
    "body": "Before you can create an account with us, we require that you first speak with your advisor. Please reach out to your advisor to receive the necessary information and guidance for your account creation process."
  },
  "linkExpiredDialog": {
    "title": "Unable to create account",
    "body": "The invitation link you used is no longer active. For security reasons, these links expire after a set time. Please reach out to your advisor or firm representative to receive a new one and continue setting up your account."
  },
  "signInErrorDialog": {
    "alreadyLinked": {
      "title": "Unable to sign in",
      "body": "This email address is already linked to another sign-in. Please contact support for help."
    },
    "noSignUpRole": {
      "title": "We can't complete your sign-in",
      "body": "There's a problem with your organization's access settings. Please contact support for help."
    },
    "generic": {
      "title": "Something went wrong",
      "body": "We couldn't complete your sign-in. Please try again."
    }
  },
  "idpLogout": {
    "closeTabMessage": "Logout complete — you may close this tab."
  }
}
